module.exports = __webpack_public_path__ + "img/Switchingcenter.265fbb90.svg";